import React from 'react';
import PropTypes from 'prop-types';
import Overflow from './ui/Overflow';

class ProductList extends React.Component {

    render() {
        return (
            <div>
                <h4>Manage products</h4>
                <div className="flex-between">
                    <input className="input-search" type="text" defaultValue={this.props.productSearch} onChange={e => this.props.filterProducts(e, 'productSearch')} placeholder="Search products"/>
                    <a className="btn btn-primary btn-with-icon" onClick={this.props.addProduct}><i className="material-icons">add_circle_outline</i>Add product</a>
                </div>
                <table className="table productTable">
                    <thead>
                        <tr>
                            <th className="iconCell">TOM</th>
                            <th className="titleCell">Title</th>
                            <th className="categoryCell">Categories</th>
                            <th className="tagCell">Access tags</th>
                            <th className="salesCell">Sales</th>
                            <th className="iconCell"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.keys(this.props.products).map(productKey => {
                                const product = this.props.products[productKey];
                                if(product) {
                                    return (
                                        <tr key={productKey}>
                                            <td className="productOfTheMonth iconCell"><a onClick={(e) => this.props.updateProductOfTheMonth(productKey)}>{this.props.globalSettings && this.props.globalSettings.productOfTheMonth === product.title ? <i className="material-icons active">star</i> : <i className="material-icons inactive">star_border</i>}</a></td>
                                            <td className="productTitle titleCell" onClick={() => this.props.showProductModal(productKey) }>{product.title}</td>
                                            <td className="categoryCell">
                                                {product.circleContent === "true" ? <img alt="Circle content" src="images/circle-icon.svg"/> : null}
                                                {product.midasRecovery === "true" ? <img alt="Midas recovery" src="images/midasRecovery-icon.svg"/> : null}
                                                {product.violetFlame === "true" ? <img alt="Violet flame" src="images/violetFlame-icon.svg"/> : null}
                                                {product.gettingStarted === "true" ? <img alt="Getting started" src="images/gettingStarted-icon.svg"/> : null}
                                                {product.deepDiveCourse === "true" ? <img alt="Deep dive" src="images/deepDive-icon.svg"/> : null}
                                            </td>
                                            <td className="tagCell">{this.props.renderTags(product.tagsForAccess, product.tagsForDenyAccess)}</td>
                                            <td className="salesCell">{product.forSale ? <i className="material-icons active">shopping_cart</i> : <i className="material-icons inactive">remove_shopping_cart</i>}</td>
                                            <td className="iconCell">
                                                <Overflow 
                                                    options={[  {label: "Edit", icon: "border_color", action: this.props.showProductModal}, 
                                                                {label: "Delete", icon: "delete", action: this.props.deleteProduct},
                                                                {label: "TOM", icon: "star", action: this.props.updateProductOfTheMonth}
                                                            ]} 
                                                    argument={productKey}
                                                />
                                            </td>
                                        </tr>
                                    );
                                }
                                else {
                                    return null;
                                }
                            })
                        }
                    </tbody>
                </table>
            </div>
        );
    }
}

ProductList.propTypes ={
    products: PropTypes.object.isRequired,
    productSearch: PropTypes.string.isRequired,
    globalSettings: PropTypes.object.isRequired,
    updateProductOfTheMonth: PropTypes.func.isRequired,
    filterProducts: PropTypes.func.isRequired,
    deleteProduct: PropTypes.func.isRequired,
    renderTags: PropTypes.func.isRequired
}

export default ProductList;


/** WEBPACK FOOTER **
 ** ./src/components/ProductList.js
 **/